<template>
<div>
</div>
</template>

<script>
import HelloSign from 'hellosign-embedded';

export default {
  props : ['clientId','embedUrl','redirectTo','cancelUrl','server'],
  data() {
    return {
      client : new HelloSign({clientId: this.clientId}),
      enableTestMode : !!this.server
  }
  },
  mounted() {
    this.client.open(this.embedUrl, {
      skipDomainVerification : this.enableTestMode,
      testMode : this.enableTestMode
    });
    this.client.on('sign', (data) => {
      this.onSign(data);
    });
    this.client.on('cancel', () => {
      this.onCancel();
    });
  },
  methods : {
    onSign(data) {
      this.client.close();
      let url = this.cleanUrl()
      window.location.href = url + data.signatureId
    },
    cleanUrl() {
      let url = this.redirectTo
      let len = url.length
      if(url.charAt(len-1)==='?')
        url=url.slice(0,len-1);
      return url
    },
    onCancel() {
      //window.location.href = this.cancelUrl
    }
  }
}
</script>

<style scoped>

</style>